const getSelectMatchKey = (input) => input.dataset.baseKey
    || input.dataset.key.replace(/__\d+$/, '');

const applySelectTargetState = (input, form) => {
    const batch = input.closest('.js-form-field-group-batch');
    const scope = batch || form;
    const matchKey = getSelectMatchKey(input);

    // A select hidden by another select's target logic is inert: it must not
    // touch its own targets, so a visible sibling of the same key (e.g. a second
    // `assurance_level` swapped in by `protocol`) can own them.
    // syncSelectFieldTargets hides every target before re-applying, so skipping
    // here leaves them hidden unless the visible sibling re-shows them.
    if (input.closest('.js-form-select-target.hidden')) {
        return;
    }

    let selectFields = [...scope.querySelectorAll(
        `.js-form-select-target[data-key="${matchKey}"]`,
    )];

    // A top-level select must not reach into any batch's targets (the same key,
    // e.g. protocol, now lives at both levels); batch selects already scope to
    // their own batch.
    if (!batch) {
        selectFields = selectFields.filter((field) => !field.closest('.js-form-field-group-batch'));
    }

    selectFields.forEach((field) => {
        const matches = field.dataset.key === matchKey && field.dataset.value === input.value;

        field.classList.toggle('hidden', !matches);
    });
};

export const syncSelectFieldTargets = (form) => {
    form.querySelectorAll('.js-form-select-target').forEach((field) => {
        field.classList.add('hidden');
    });

    form.querySelectorAll('.js-form-select').forEach((input) => {
        applySelectTargetState(input, form);
    });
};

export const initSelectFieldTargets = (root) => {
    const form = root.closest?.('.js-form') || root;

    if (!form?.querySelectorAll) return;

    form.querySelectorAll('.js-form-select:not([data-select-target-init])').forEach((input) => {
        input.dataset.selectTargetInit = 'true';

        applySelectTargetState(input, form);

        input.addEventListener('change', () => {
            // Re-sync the whole form, not just this select: changing one select
            // (e.g. protocol) can show/hide another select of the same key
            // (e.g. a second assurance_level), whose own targets must then be
            // re-evaluated. Selects apply in DOM order, so a parent's new state
            // is set before its dependents read it.
            syncSelectFieldTargets(form);
        });
    });
};
